/*
 * @Author: lzy
 * @Date: 2021-04-26 10:43:28
 * @LastEditTime: 2021-05-11 16:08:28
 * @LastEditors: lzy
 * @Description: 取签产品过滤组件
 * @FilePath: \xjmediacloud\app\resourceCenter\directive\compositeFilterPanel\recommendChannels\recommendChannels.js
 */
angular.module('compositeFilterPanelModule').directive('recommendChannelsFilter', ['$timeout', 'trsHttpService', 'trsspliceString',
    function($timeout, trsHttpService, trsspliceString) {
        return {
            restrict: 'EA',
            // replace: true,
            templateUrl: './resourceCenter/directive/compositeFilterPanel/recommendChannels/recommendChannels.html',
            scope: {
                docShareMedia: '=', // 推荐渠道
                sites: '=', // 渠道列表
                callback: '&'
            },
            link: function ($scope, iEle) {
                initStatus();

                /**
                 * [initStatus description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        recommendedChannels: [],
                        selectedChannels: []
                    };
                }

                /**
                 * [channelSelected description]选择产品时的回调函数
                 *
                 * @param   {[type]}  channel  [channel description]
                 *
                 * @return  {[type]}           [return description]
                 */
                $scope.channelSelected = function (channel) {
                    var index = $scope.data.selectedChannels.indexOf(channel);
                    if (index !== -1) {
                        $scope.data.selectedChannels.splice(index, 1);
                    } else {
                        $scope.data.selectedChannels.push(channel);
                    }
                };

                $scope.confirm = function() {
                    $scope.data.selectedChannelName = trsspliceString.spliceString($scope.data.selectedChannels, 'MEDIANAME', '、');
                    $scope.docShareMedia = trsspliceString.spliceString($scope.data.selectedChannels, 'MEDIATYPE', ',');
                    $timeout(function() {
                        $scope.callback();
                    });
                };

                $scope.reset = function() {
                    $scope.data.selectedChannels = [];
                };
            }
        };
    }
]);
